import React, { useEffect } from 'react';
import { CloseModalButton } from '../Button';
import { StyledModal, StyledModalWrapper, StyledModalHeading } from '../Styled';

interface IModal {
  onCloseClick?: () => void;
  width?: string;
  paddingBottom?: string;
  paddingTop?: string;
  headerText?: string;
  headerColor?: string;
  children?: React.ReactNode; // Add this line to explicitly include children
}

export const Modal: React.FC<IModal> = (props): JSX.Element => {
  const { children, onCloseClick, width, paddingBottom, paddingTop, headerText, headerColor } = props;

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <StyledModalWrapper>
      <StyledModal width={width} paddingBottom={paddingBottom} paddingTop={paddingTop}>
        {onCloseClick && <CloseModalButton onClick={onCloseClick} ariaLabel="close modal window" />}
        {headerText && <StyledModalHeading color={headerColor}>{headerText}</StyledModalHeading>}
        {children}
      </StyledModal>
    </StyledModalWrapper>
  );
};
